import type { ButtonHTMLAttributes } from 'react';

type Variante = 'primario' | 'secundario' | 'fantasma' | 'exito' | 'peligro';

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  variante?: Variante;
  bloque?: boolean;
  grande?: boolean;
  cargando?: boolean;
  /** false = esquinas rounded-lg (a juego con los textbox) en vez de píldora. */
  redondeoCompleto?: boolean;
}

const VARIANTES: Record<Variante, string> = {
  primario: 'bg-navy text-white hover:bg-navy/90 disabled:hover:bg-navy',
  secundario:
    'bg-white text-navy border border-borde hover:border-navy/40 disabled:hover:border-borde',
  fantasma: 'bg-transparent text-navy hover:bg-navy/5',
  exito: 'bg-emerald-600 text-white hover:bg-emerald-700 disabled:hover:bg-emerald-600',
  peligro: 'bg-transparent text-red-600 hover:bg-red-50',
};

export function Button({
  variante = 'primario',
  bloque,
  grande,
  cargando,
  redondeoCompleto = true,
  disabled,
  children,
  className,
  ...rest
}: Props) {
  const clases = [
    'inline-flex items-center justify-center gap-2 font-medium transition active:scale-[0.98] disabled:cursor-not-allowed disabled:opacity-50 disabled:active:scale-100',
    redondeoCompleto ? 'rounded-full' : 'rounded-lg',
    'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-navy/30 focus-visible:ring-offset-2 focus-visible:ring-offset-fondo',
    grande ? 'px-6 py-3.5 text-base' : 'px-5 py-2.5 text-sm',
    bloque && 'w-full',
    VARIANTES[variante],
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <button
      className={clases}
      disabled={disabled || cargando}
      aria-busy={cargando || undefined}
      {...rest}
    >
      {cargando && (
        <span
          className="h-4 w-4 animate-spin rounded-full border-2 border-current/30 border-t-current"
          aria-hidden="true"
        />
      )}
      {children}
    </button>
  );
}
